import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "transaction-list",
  "use": "transaction-list-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"transaction-list\"><path d=\"M5.5 3h11A1.5 1.5 0 0118 4.5v14a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 014 18.5v-14A1.5 1.5 0 015.5 3zM6 4a1 1 0 00-1 1v13a1 1 0 001 1h10a1 1 0 001-1V5a1 1 0 00-1-1H6zm1.5 11h7a.5.5 0 110 1h-7a.5.5 0 110-1zm0-4h7a.5.5 0 110 1h-7a.5.5 0 110-1zm0-4h7a.5.5 0 110 1h-7a.5.5 0 010-1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol